import { isHostLocal } from "app/static/frontend/imports/helpers"

/**
 * frontend version of app/grassroots/functions.py:generate_action_center_link
 * subdomain -> the subdomain for the action center. Could be something like 'whale' or 'saveourwhales.org'
 * path - the rest of the path you are trying to linl. Ex: '/campaign/123123/'
 * params - Key, value of the query params wanted
 * returns - the concatenated url for the action center
 */
export const generateActionCenterLink = (subdomain: string, path?: string, params?): string => {
    if (!subdomain) {
        return
    }

    // If we're using a known localhost domain, point to the localhost testing domain
    const baseHost = isHostLocal(document.location.host) ? ".quorum.club" : ".quorum.us"

    const subdomainPieces = subdomain.split(".")

    let url
    if (subdomainPieces.length === 2) {
        url = `https://www.${subdomain}/`
    } else if (subdomainPieces.length === 3) {
        url = `https://${subdomain}/`
    } else {
        url = `https://${subdomain}${baseHost}/`
    }

    if (path) {
        path = path.endsWith("/") ? path : path + "/"
        path = path.startsWith("/") ? path.slice(1) : path
        url = url + path
    }
    if (params) {
        url = url + "?"
        for (const key of Object.keys(params)) {
            url = url + `${key}=${params[key]}&`
        }
    }
    return url
}

/**
 * Open the given url in a new tab or window
 * @function - openLink
 * @param {string} - url -> URL of page to open in new tab or window
 */
export const openLink = (url) => url && window.open(url, "_blank", "noopener,noreferrer")
